/**
 * Clerk configuration for Create React App.
 * CRA exposes only REACT_APP_* at build time; sync-clerk-env copies from root .env.
 */

const publishableKey =
  process.env.REACT_APP_CLERK_PUBLISHABLE_KEY ||
  process.env.VITE_CLERK_PUBLISHABLE_KEY ||
  '';

export function getClerkPublishableKey() {
  return publishableKey.trim();
}

export function assertClerkConfigured() {
  const key = getClerkPublishableKey();
  if (!key) {
    throw new Error(
      'Missing Clerk publishable key. Set REACT_APP_CLERK_PUBLISHABLE_KEY in DocAgent-UI/.env.local ' +
        '(run npm start to auto-sync from root .env) or set VITE_CLERK_PUBLISHABLE_KEY in the repo root .env.'
    );
  }
  if (!key.startsWith('pk_')) {
    throw new Error('REACT_APP_CLERK_PUBLISHABLE_KEY must start with pk_');
  }
  return key;
}

export const CLERK_SIGN_IN_URL = '/login';
export const CLERK_SIGN_UP_URL = '/signup';
export const CLERK_AFTER_SIGN_IN_URL = '/dashboard';
export const CLERK_AFTER_SIGN_UP_URL = '/dashboard';
